/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(source) {
	this.cacheable && this.cacheable();
	var value = typeof source === "string" ? JSON.parse(source) : source;
	this.value = [value];
	return "module.exports = " + JSON.stringify(value, undefined, "\t") + ";";
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader/index.js
 ** module id = ./node_modules/json-loader/index.js
 ** module chunks = 1
 **/